// extracted by mini-css-extract-plugin
export default {"button":"button--T3ANT","primary":"primary--XEkN5"};